// Bileli · modules/media/lib — IndexedDB store for the picked File itself (the resume secret #1). why:
// after a reload the byte upload can only continue if the actual File is still available; localStorage
// can't hold blobs, IndexedDB can (structured clone preserves name/size/lastModified, so the tus
// fingerprint reconstructs identically). Best-effort everywhere — a failure must never block an upload.

import { MEDIA_TTL_MS } from './lsUtil';

const DB_NAME = 'bileli-media';
const STORE = 'upload-blobs';

interface BlobRecord { assetId: string; file: File; savedAt: number }

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) {
        req.result.createObjectStore(STORE, { keyPath: 'assetId' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function run<T>(mode: IDBTransactionMode, fn: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await openDb();
  try {
    return await new Promise<T>((resolve, reject) => {
      const tx = db.transaction(STORE, mode);
      const req = fn(tx.objectStore(STORE));
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  } finally {
    db.close();
  }
}

export async function putUploadFile(assetId: string, file: File): Promise<void> {
  try {
    await run('readwrite', (s) => s.put({ assetId, file, savedAt: Date.now() } satisfies BlobRecord));
  } catch {
    // best-effort
  }
}

export async function getUploadFile(assetId: string, now = Date.now()): Promise<File | undefined> {
  try {
    const rec = await run<BlobRecord | undefined>(
      'readonly', (s) => s.get(assetId) as IDBRequest<BlobRecord | undefined>,
    );
    if (!rec) return undefined;
    if (now - rec.savedAt >= MEDIA_TTL_MS) {
      void deleteUploadFile(assetId);
      return undefined;
    }
    return rec.file;
  } catch {
    return undefined;
  }
}

export async function deleteUploadFile(assetId: string): Promise<void> {
  try {
    await run('readwrite', (s) => s.delete(assetId));
  } catch {
    // best-effort
  }
}
